<template>
  <LinkCard :image="thumbnail" :title="$path('name', value)" :subtitle="subtitle" :to="action" :is-list="isList" />
</template>

<script>
import LinkCard from '@/components/LinkCard'

import { Currency } from '@/filters'

export default {
  props: {
    value: Object,
    theme: {
      type: String,
      enum: ['default', 'list'],
      default: 'default',
    },
  },
  computed: {
    isList() {
      return this.theme === 'list'
    },
    action() {
      return { name: 'product-edit', params: { id: this.value.id } }
    },
    subtitle() {
      return Currency(this.value.pricing.value)
    },
    thumbnail() {
      let item = (this.$path('value.images') || []).find(({ type }) => type.startsWith('image'))
      if (!item) return

      return { src: item.url, alt: this.value.name }
    },
    badges() {
      if (this.value.isEntry) return [{ theme: 'primary', value: this.$t('unitSelectorIsEntry') }]
      return []
    },
  },
  components: {
    LinkCard,
  },
}
</script>
